import {
	SCHEDULE_ACTION_TYPES,
	SCHEDULE_TASKS_FILTER_VALUES,
	ScheduleAction,
	TasksState,
} from '../../../../types/schedule'

const initialState: TasksState = {
	tasks: [],
	filter: SCHEDULE_TASKS_FILTER_VALUES.UPCOMING_TODAY,
	selectedTasks: [],
	taskTypes: [],
	taskPriorities: [],
	taskStatuses: [],
	taskAccounts: [],
	taskSearch: '',
}

export default (state = initialState, action: ScheduleAction): TasksState => {
	switch (action.type) {
		case SCHEDULE_ACTION_TYPES.SCHEDULE_TASKS_GET: {
			return {
				...state,
				tasks: action.payload,
			}
		}
		case SCHEDULE_ACTION_TYPES.SCHEDULE_TASKS_SET_FILTER: {
			return {
				...state,
				filter: action.payload,
			}
		}
		case SCHEDULE_ACTION_TYPES.SCHEDULE_TASKS_SET_DONE_STATUS_FOR_TASK: {
			const updatedTasks = state.tasks.map(task => {
				if (task._id === action.payload.id) {
					return {
						...task,
						settings: {
							...task.settings,
							status: action.payload.status,
						},
					}
				}
				return task
			})

			return {
				...state,
				tasks: updatedTasks,
			}
		}
		case SCHEDULE_ACTION_TYPES.SCHEDULE_TASKS_DELETE_TASK: {
			const updatedTasks = state.tasks.filter(task => task._id !== action.payload)

			return {
				...state,
				tasks: updatedTasks,
			}
		}
		case SCHEDULE_ACTION_TYPES.SCHEDULE_TASK_SELECT: {
			const newSelectedTasksArray = [...state.selectedTasks, action.payload]

			return {
				...state,
				selectedTasks: newSelectedTasksArray,
			}
		}

		case SCHEDULE_ACTION_TYPES.SCHEDULE_TASK_UNSELECT: {
			const newSelectedTasksArray = state.selectedTasks.filter(
				taskId => taskId !== action.payload

			)
			return { ...state, selectedTasks: newSelectedTasksArray }
		}

		case SCHEDULE_ACTION_TYPES.SCHEDULE_TASK_SELECT_ALL: {
			const allTasksId = state.tasks.map(task => task._id)

			return {
				...state,
				selectedTasks: allTasksId,
			}
		}

		case SCHEDULE_ACTION_TYPES.SCHEDULE_TASK_UNSELECT_ALL: {
			return {
				...state,
				selectedTasks: [],
			}
		}
		case SCHEDULE_ACTION_TYPES.SET_TASK_TYPES: {
			return {
				...state,
				taskTypes: [...action.payload],
			}
		}
		case SCHEDULE_ACTION_TYPES.SET_TASK_PRIORITIES: {
			return {
				...state,
				taskPriorities: [...action.payload],
			}
		}
		case SCHEDULE_ACTION_TYPES.SET_TASK_STATUSES: {
			return {
				...state,
				taskStatuses: [...action.payload],
			}
		}
		case SCHEDULE_ACTION_TYPES.SET_TASK_ACCOUNTS: {
			return {
				...state,
				taskAccounts: [...action.payload],
			}
		}
		case SCHEDULE_ACTION_TYPES.SET_TASK_SEARCH: {
			return {
				...state,
				taskSearch: action.payload || '',
			}
		}

		default: {
			return state
		}
	}
}
